// Import images
import AmazonImage from "../images/brands/amazon_gray.png";
import SonyImage from "../images/brands/sony_gray.png";
import AdidasImage from "../images/brands/adidas_gray.png";
import FilaImage from "../images/brands/fila_gray.png";
import NBImage from "../images/brands/nb_gray.png";
import SamsungImage from "../images/brands/samsung_gray.png";
import CanonImage from "../images/brands/canon_gray.png";
import PumaImage from "../images/brands/puma_gray.png";

import A1 from "../images/skills/A1.png";
import A2 from "../images/skills/A2.png";
import A3 from "../images/skills/A3.png";
import A4 from "../images/skills/A4.png";
import A5 from "../images/skills/A5.png";
import A6 from "../images/skills/A6.png";
import A7 from "../images/skills/A7.png";
import A8 from "../images/skills/A8.png";
import A9 from "../images/skills/A9.png";
import A10 from "../images/skills/A10.png";
import A11 from "../images/skills/A11.png";
import A12 from "../images/skills/A12.png";
import A13 from "../images/skills/A13.png";
import A14 from "../images/skills/A14.png";
import A15 from "../images/skills/A15.png";
import A16 from "../images/skills/A16.png";
import A17 from "../images/skills/A17.png";
import A18 from "../images/skills/A18.png";
import A19 from "../images/skills/A19.png";
import A20 from "../images/skills/A20.webp";
import A21 from "../images/skills/A21.png";
import A22 from "../images/skills/A22.png";
import A23 from "../images/skills/A23.png";
import A24 from "../images/skills/A24.png";
import A25 from "../images/skills/A25.png";
import A26 from "../images/skills/A26.png";

import A27 from "../images/certificate/A27.png";
import A28 from "../images/certificate/A28.png";
import A29 from "../images/certificate/A29.png";
import A30 from "../images/certificate/A30.png";
import A31 from "../images/certificate/A31.png";

import A90 from "../images/skills/A90.jpeg";
import A91 from "../images/skills/A91.png";
import A93 from "../images/skills/A93.png";
import A94 from "../images/skills/A94.png";
import A95 from "../images/skills/A95.jpeg";
import A96 from "../images/skills/A96.jpg";
import A97 from "../images/skills/A97.png";
import A98 from "../images/skills/A98.png";

import Python from "../images/skills/Python.png";
import JS from "../images/skills/JS1.png";
import Springboot from "../images/skills/Springboot.png";
import SpringDataJPA from "../images/skills/SDJ.png";
import SpringSecurity from "../images/skills/SS.jpeg";
import ES from "../images/skills/ES.png";
import Kafka from "../images/skills/Kafka.png";
import Postgres from "../images/skills/postgre.jpg";
import MongoDB from "../images/skills/Mongodb.jpg";
import JUnit from "../images/skills/Junit.png";
import Mockito from "../images/skills/Mockito.png";
import Css from "../images/skills/css.jpeg";
import Html from "../images/skills/html.png";
import React from "../images/skills/react.jpg";
import S3 from "../images/skills/s3.png";
import EC2 from "../images/skills/EC2.png";
import Docker from "../images/skills/docker.png";
import Kubernetes from "../images/skills/Kubernetes.jpg";
import Rest from "../images/skills/rest.png";
import Linux from "../images/skills/Linux.png";
import JSON from "../images/skills/json.png";
import Jenkins from "../images/skills/Jenkins.jpeg";


export const clientsHeading = "Some of the brands that trust me";

export const clientsData = [
    //Languages
  {
    id: 1,
    title: "skill",
    img: Python,
    //Python
  },
  {
    id: 2,
    title: "skill",
    img: A2,
    //Java
  },
  {
    id: 3,
    title: "skill",
    img: A4,
    //C++
  },
  {
    id: 4,
    title: "skill",
    img: JS,
    //Java script
  },
  //Backend Technologies

  {
    id: 5,
    title: "skill",
    img: A13,
    //Spring
  },
  {
    id: 6,
    title: "skill",
    img: Springboot,
    //Spring boot
  },
  {
    id: 101,
    title: "skill",
    img: Rest,
    //rest api
  },

  {
    id: 7,
    title: "skill",
    img: SpringDataJPA,
    //Spring Data JPA
  },

  {
    id: 8,
    title: "skill",
    img: SpringSecurity,
    //Spring Security
  },

  {
    id: 102,
    title: "skill",
    img: JSON,
    //json
  },

  {
    id: 9,
    title: "skill",
    img: ES,
    //Elastic Search
  },

  {
    id: 10,
    title: "skill",
    img: Kafka,
    //Apache Kafka
  },
  //Testing
  {
    id: 11,
    title: "skill",
    img: A91,
    //selenium
  },
  {
    id: 12,
    title: "skill",
    img: JUnit,
    //Junit
  },
  {
    id: 13,
    title: "skill",
    img: Mockito,
    //Mockito
  },
  //Databases
  {
    id: 14,
    title: "skill",
    img: A6,
    //Mysql
  },
  {
    id: 15,
    title: "skill",
    img: Postgres,
    //Postgres
  },
  {
    id: 16,
    title: "skill",
    img: MongoDB,
    //MongoDB
  },
  //FrontEnd
  {
    id: 17,
    title: "skill",
    img: A11,
    //Node
  },
  {
    id: 18,
    title: "skill",
    img: Html,
    //html
  },
  {
    id: 19,
    title: "skill",
    img: Css,
    //css
  },
  {
    id: 20,
    title: "skill",
    img: React,
    //react
  },

  {
    id: 21,
    title: "skill",
    img: A12,
    //Bootstrap
  },

  {
    id: 22,
    title: "skill",
    img: A96,
    //aws
  },
  {
    id: 23,
    title: "skill",
    img: S3,
    //aws
  },
  {
    id: 24,
    title: "skill",
    img: EC2,
    //aws
  },
  {
    id: 25,
    title: "skill",
    img: A97,
    //azure
  },

  {
    id: 26,
    title: "skill",
    img: A93,
    //github
  },
  {
    id: 27,
    title: "skill",
    img: A94,
    //git
  },
  {
    id: 103,
    title: "skill",
    img: Jenkins,
    //Jenkins
  },

  {
    id: 28,
    title: "skill",
    img: Docker,
    //docker
  },

  {
    id: 29,
    title: "skill",
    img: Kubernetes,
    //Kubernetes
  },

  {
    id: 30,
    title: "skill",
    img: Linux,
    //Linux
  },

  {
    id: 14,
    title: "skill",
    img: A14,
    //dsa
  },
  {
    id: 15,
    title: "skill",
    img: A15,
    //wordpress
  },
  {
    id: 32,
    title: "skill",
    img: A90,
    //solidity
  },



  {
    id: 16,
    title: "skill",
    img: A16,
    //salesforce
  },
  {
    id: 17,
    title: "skill",
    img: A17,
    //apex
  },

  {
    id: 22,
    title: "skill",
    img: A22,
    //service cloud
  },
  {
    id: 23,
    title: "skill",
    img: A23,
    //sales cloud
  },
  {
    id: 24,
    title: "skill",
    img: A24,
    //powerpoint
  },
  {
    id: 25,
    title: "skill",
    img: A25,
    //excel
  },
  {
    id: 26,
    title: "skill",
    img: A26,
    //Mathlab
  },


  {
    id: 27,
    title: "certificate",
    img: A27,
  },
  {
    id: 28,
    title: "certificate",
    img: A28,
  },
  {
    id: 29,
    title: "certificate",
    img: A29,
  },
  {
    id: 30,
    title: "certificate",
    img: A30,
  },
  {
    id: 31,
    title: "certificate",
    img: A31,
  },
];
